import { VectorLayer, VectorLayer2 } from './Layer.js';
import { outlineCensus } from './MapVectorStyles.js';
import * as LQ from '../controller/LayerQueries';
import { useState, useEffect, useContext } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import MapContext from '../controller/MapProvider';
import { useAfterInit } from '../controller/useAfterInit.js';
import * as mapStyles from '../view/MapVectorStyles.js';

const CensusLayer = (props) => {
    const generateDataSlug = () => theme.slug;
    const { opacity, zIndex, onLoadStatus, map } = props;
    const { scope, tract, theme, year, usState, setErrorMessage, opacity: globalOpacity, censusEnabled } = useContext(InterfaceContext);
    const { fips } = useContext(MapContext);

    const [visible, setVisible] = useState(() => tract === 'census' && censusEnabled);

    const [localOpacity, setLocalOpacity] = useState(opacity);
    const [features, setFeatures] = useState([]);
    const [loadStatus, setLoadStatus] = useState(1);
    const [lyr, setLyr] = useState(null);

    const [selected_data_slug, setSelectedDataSlug] = useState(() => generateDataSlug());

    const setBlendMode = (e) => (e.context.globalCompositeOperation = 'multiply');
    const updateSlug = () => setSelectedDataSlug(generateDataSlug());

    useEffect(() => setVisible(tract === 'census' && censusEnabled), [tract, censusEnabled]);
    useEffect(() => {
        if (!visible) onLoadStatus(1);
    }, [visible]);

    useEffect(() => updateSlug(), [scope, theme, tract]);
    useEffect(() => setLocalOpacity((opacity || 1) * (globalOpacity / 100)), [opacity, globalOpacity]);
    useEffect(() => onLoadStatus(loadStatus), [loadStatus]);
    useEffect(
        () =>
            lyr &&
            lyr.once('postrender', () => {
                // console.log('*** CENSUS, rendered');
                setLoadStatus(1);
            }),
        [features]
    );

    //@@==
    useAfterInit(() => {
        if (!visible) return;
        console.log('load here 1');
        setLoadStatus(0);
        refreshColors();
    }, [selected_data_slug]);

    //@@==
    useAfterInit(() => {
        if (!visible) return;
        console.log('load here 2');
        setLoadStatus(0);
        refreshSVI();
    }, [usState, scope]);

    //@@==
    useAfterInit(() => {
        if (!visible || fips.size === 0) return;
        console.log('load here 3');
        setLoadStatus(0);
        refreshFeatures();
    }, [year, visible, fips, scope]);

    const getGeometry = async (ffips) => {
        var zoom = map.getView().getZoom();
        var newfeatures = await LQ.getVisibleGeometry({
            zoom,
            scope: 'state',
            tract: 'census',
            state: usState,
            fipsList: ffips,
            year: year.label
        }).catch((err) => {
            setErrorMessage(err.modalMessage, err);
            return [];
        });
        return newfeatures || [];
    };
    const getSvi = async (fips) => {
        const canDecorate = scope === 'national' || usState;
        let localScope = usState ? 'state' : scope;
        const shouldGetSvi = Boolean(tract === 'census' && canDecorate && features);
        if (!shouldGetSvi) return {};

        return await LQ.getVisibleSVI({
            theme: theme.id,
            year: year.label,
            scope: localScope,
            tract: 'census',
            state: usState,
            fips
        }).catch((err) => {
            console.error('Failed to load SVI data in census layer');
            console.error(err);
            setErrorMessage(err.modalMessage, err);
            setLoadStatus(1);
        });
    };
    const refreshFeatures = async (success = () => {}, failure = () => {}) => {
        console.log('fips in view', fips);
        const newfeatures = await getGeometry(fips);
        const svi = await getSvi(fips);
        const decorated = decorateFeatures(newfeatures, svi);
        setFeatures(decorated);
        success(decorated);
    };

    const decorateFeatures = (features, svi) => {
        let localScope = usState ? 'state' : scope;
        return LQ.stylizeGeometry(features, localScope, theme, usState, svi, false);
    };
    const featureWithinScope = (shape) => {
        if (scope == 'national') return true;
        if (!usState) return false;
        const fips = shape.get('FIPS') || shape.get('STATEFP');
        return fips.substr(0, 2) === usState.id + '';
    };
    const getStyleFromFeature = (shape) => {
        if (!featureWithinScope(shape)) return mapStyles.outOfScope;
        const val = shape.get('sviValues')['theme' + theme.id];
        return theme.colorScheme[val] || mapStyles.noData;
    };
    const restyleFeatures = (features) => {
        features.forEach((shape) => {
            let sviStyle = getStyleFromFeature(shape);
            if (typeof sviStyle == 'object') shape.setStyle(sviStyle);
        });
    };
    const refreshColors = () => {
        restyleFeatures(features);
        setFeatures(features.slice(0));
    };
    const refreshSVI = async () => {
        const svi = await getSvi(fips);
        const decorated = decorateFeatures(features.slice(), svi);
        setFeatures(decorated);
    };

    return <VectorLayer2 title={'Census'} className={'ol-layer svi'} style={outlineCensus} opacity={localOpacity} features={features} visible={visible} zIndex={zIndex} map={map} onPreRender={setBlendMode} onAdded={(lyr) => setLyr(lyr)} />;
};
export default CensusLayer;
